webpackJsonp([10],{

/***/ "0Flw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/index.js


var _mutations;




//import modules from './modules';

vue_esm["default"].use(vuex_esm["a" /* default */]);

var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = 'LOGOUT';
var SET_ROLE = 'SET_ROLE';
var DYN_CON_DONE = 'DYN_CON_DONE';
var DYN_CONTENT_LOADED = 'DYN_CONTENT_LOADED';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
    state: {
        lngFront: 'fr',
        contents: [],
        selects: [],
        isDynContentLoaded: false,

        window: {
            width: '',
            scroll: 0
        },
        user: {
            isLoggedIn: false,
            role: null,
            login: null,
            id: null
        },
        appRootPath: null,
        navProjects: { cat: '', heading: '', active: false }
    },
    getters: {
        getWindowSize: function getWindowSize(state) {
            return state.window;
        },
        getUserRole: function getUserRole(state) {
            return state.userRole;
        },
        getContents: function getContents(state) {
            return state.contents;
        },
        isDynContLoaded: function isDynContLoaded(state) {
            return state.isDynContentLoaded;
        },
        currentLng: function currentLng(state) {
            return state.lngFront;
        }
    },
    mutations: (_mutations = {}, defineProperty_default()(_mutations, DYN_CONTENT_LOADED, function (state) {
        state.isDynContentLoaded = true;
    }), defineProperty_default()(_mutations, LOGIN_SUCCESS, function (state, data) {
        //console.log("LOGIN_SUCCESS");
        //console.log(data);
        state.user.isLoggedIn = true;
        state.user.role = data.user_right;
        state.user.id = data.user_id;
        state.user.login = data.login;
        state.appRootPath = '/communaute';
    }), defineProperty_default()(_mutations, LOGOUT, function (state) {
        state.user = {
            isLoggedIn: false,
            role: null,
            id: null
        };
        state.appRootPath = '/';
        //state.isAdmin = false;
    }), _mutations),
    actions: {
        login: function login(_ref, creds) {
            var state = _ref.state,
                commit = _ref.commit;

            commit(LOGIN_SUCCESS, creds);
        },
        logout: function logout(_ref2) {
            var state = _ref2.state,
                commit = _ref2.commit;

            commit(LOGOUT);
        },
        dynContentLoaded: function dynContentLoaded(_ref3) {
            var state = _ref3.state,
                commit = _ref3.commit;

            commit(DYN_CONTENT_LOADED);
        }
    }
    //modules
}));
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/config/env.js
var DOMAIN_TITLE = 'PLEO Admin';
var DOMAIN =  false ? 'https://pleo.wearenotalone.fr/index.php' : 'https://' + window.location.hostname + '/index.php';
//export const WWW_IMAGE_PATH = `https://pleo.wearenotalone.fr/images/`;
var API_URL = '' + DOMAIN;
// export const API_PORT = `5000`;
// export const API_URL = `${DOMAIN}:${API_PORT}`;
// CONCATENATED MODULE: ./src/router/routes.js


var routes = [{
    path: '/login',
    name: 'Login',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P7ry")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: DOMAIN_TITLE + ' | Login', auth: false, front: true }
}, {
    path: '/',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eerB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { auth: true, front: false },
    children: [, {
        path: '/',
        redirect: 'accueil'
    }, {
        path: 'accueil',
        name: 'home',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HXef")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true }
    }, {
        path: 'nous',
        name: 'us',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PLF0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, id: 'us' }
    }, {
        path: 'activites',
        name: 'activity',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("s+Vr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, id: 'activity' }
    }, {
        path: 'rejoindre',
        name: 'join',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PLF0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, id: 'join' }
    }, {
        path: 'contact',
        name: 'contact',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uRks")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, id: 'contact' }
    }, {
        path: 'cgu',
        name: 'cgu',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PLF0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, id: 'cgu' }
    }, {
        path: 'mentions-legales',
        name: 'mentions',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PLF0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, id: 'mentions' }
    }, {
        path: 'communaute',
        name: 'community',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ihGD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: true, front: true, id: 'community' }
    }]
}, {
    path: '*',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c5Mg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: DOMAIN_TITLE + ' | Erreur 404' }
}];
// CONCATENATED MODULE: ./src/router/index.js




vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
    routes: routes
    //mode: 'history',
    //linkActiveClass: "active"    
    //linkActiveClass: 'has-current',
    //hashbang: false,
});
//router.mode ='html5';
//router.beforeEach(guardRoute);


/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/mixins/auth.js
/* harmony default export */ var auth = ({
    methods: {
        $checkUser: function $checkUser() {
            var _this = this;

            //console.log("checkUser:" + this.$store.state.user.isLoggedIn);
            //console.log(this.$store.state.user);
            if (this.$store.state.user.isLoggedIn) return;
            this.$AJAX.getUser().then(function (data) {
                if (checkResultLog(data)) _this.$store.dispatch('login', data);
            });
        },
        $checkAuth: function $checkAuth() {
            var _this2 = this;

            //console.log("checkAuth:" + this.$store.state.user.isLoggedIn);
            //console.log(this.$store.state.user);
            if (this.$store.state.user.isLoggedIn) return;
            this.$AJAX.getUser().then(function (data) {
                if (checkResultLog(data)) _this2.$store.dispatch('login', data);else {
                    _this2.$processDataMsg(data);
                    _this2.$router.push("login");
                }
            });
        },
        $logCredentials: function $logCredentials(creds) {
            var _this3 = this;

            //console.log("logCredientials");
            if (this.$store.state.user.isLoggedIn) return;

            this.$AJAX.checkLoggin(creds).then(function (data) {
                //-- 100 is for logging, valid is for currentUser query at each route

                if (checkResultLog(data)) {
                    _this3.$store.dispatch('login', data);
                    _this3.$router.push(_this3.$store.state.appRootPath);
                } else _this3.$processDataMsg(data);
            });
        },
        $isAdmin: function $isAdmin() {
            if (this.$store.state.user.role == "admin") return true;
            return false;
        },
        $isManager: function $isManager() {
            if (this.$store.state.user.role == "manager") return true;
            return false;
        },
        $isUser: function $isUser() {
            if (this.$checkNull(this.$store.state.user.role)) return true;
            return false;
        }
    }
});

function checkResultLog(data) {
    if (data.code === '100' || data.status === 'valid') {
        return true;
    } else {
        return false;
    }
}
// EXTERNAL MODULE: ./src/mixins/helpers.js
var helpers = __webpack_require__("MNMD");

// CONCATENATED MODULE: ./src/mixins/index.js





vue_esm["default"].mixin(auth);
vue_esm["default"].mixin(helpers["b" /* default */]);
// CONCATENATED MODULE: ./src/thirdparty/options.js
// mini-toastr config
var toastrOptions = {
    timeout: 4000
};
// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/esm/index.js + 283 modules
var esm = __webpack_require__("Tqaz");

// EXTERNAL MODULE: ./node_modules/mini-toastr/mini-toastr.js
var mini_toastr = __webpack_require__("EMpD");

// CONCATENATED MODULE: ./src/thirdparty/index.js






// Notification messages initialization
var notification = {
    install: function install(Vue, options) {
        Vue.prototype.$Notification = mini_toastr["a" /* default */].init(toastrOptions);
    }
};

var mods = [{ modName: esm["a" /* default */] }, { modName: notification }];

var components = [{ name: vue_select_default.a, id: 'v-select' }];

mods.forEach(function (mod) {
    return vue_esm["default"].use(mod.modName, mod.option ? mod.option : null);
});
components.forEach(function (component) {
    return vue_esm["default"].component(component.id, component.name);
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/services/base.service.js


//import Vue from 'vue';





var client = axios_default.a.create({
    baseURL: API_URL,
    withCredentials: true,
    responseType: 'json',
    headers: { 'Content-Type': 'multipart/form-data' }
});

/* harmony default export */ var base_service = ({
    execute: function execute(method, resource, data) {
        var _this = this;

        return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', client({
                                method: method,
                                url: resource,
                                data: data
                            }).then(function (response) {
                                //console.log("base.service.js GLOBAL LOG ajax query method:" + method + " url:" + resource);
                                //console.log(response.data);
                                return response.data;
                            }).catch(function (error) {
                                // handle unexpected error
                                //console.log(error);
                                //console.log(this);

                                mini_toastr["a" /* default */].init(toastrOptions);
                                mini_toastr["a" /* default */].error("Erreur de connexion, contacter votre administrateur ou patienter quelques instant et ré-essayez:" + error);
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    // AUTH methods
    checkLoggin: function checkLoggin(data) {
        return this.execute('post', '/UserSession/login', data);
    },
    getUser: function getUser() {
        return this.execute('get', '/UserSession/currentUser');
    },

    // default service methods
    get: function get(resource, option) {
        return this.execute('get', '' + resource, option);
    },
    post: function post(resource, data) {
        return this.execute('post', '' + resource, data);
    }
});
// EXTERNAL MODULE: ./node_modules/vue-meta/dist/vue-meta.esm.js
var vue_meta_esm = __webpack_require__("f3bp");

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__("Jmt5");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.css
var dist_vue_select = __webpack_require__("R870");
var dist_vue_select_default = /*#__PURE__*/__webpack_require__.n(dist_vue_select);

// EXTERNAL MODULE: ./src/scss/core.scss
var core = __webpack_require__("8Eth");
var core_default = /*#__PURE__*/__webpack_require__.n(core);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/Index.vue
//
//
//
//


/* harmony default export */ var Index = ({
    name: 'AppLayout',
    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d301e0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_Index = (esExports);
// CONCATENATED MODULE: ./src/layout/Index.vue
function injectStyle (ssrContext) {
  __webpack_require__("9UPm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d301e0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Index,
  layout_Index,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_layout_Index = (Component.exports);

// CONCATENATED MODULE: ./src/app.init.js








//-- Meta rewriting


vue_esm["default"].use(vue_meta_esm["a" /* default */], {
    // optional pluginOptions
    refreshOnceOnNavigation: true
});

//-- Basic bootstrap



//-- V-Select


//import 'font-awesome/css/font-awesome.min.css';




vue_esm["default"].config.productionTip = false;

var API = {
    install: function install(Vue, options) {
        Vue.prototype.$AJAX = base_service;
    }
};

vue_esm["default"].use(API);

(function () {
    return new vue_esm["default"]({
        name: 'Root',
        template: '<AppLayout />',
        components: {
            AppLayout: src_layout_Index
        },
        el: '#app',
        router: src_router,
        store: store,
        mounted: function mounted() {
            var _this = this;

            //console.log(router)
            src_router.beforeEach(function (to, from, next) {
                //-- Rewrite title for admin               
                if (to.meta.front === false) _this.$updatePageTitle(to, from, next);
                next();
            });

            src_router.afterEach(function (to, from, next) {
                //console.log("ROUTER -> "+to.meta.auth);
                if (to.meta.auth === true) {
                    //console.log(to.meta);
                    _this.$checkAuth();
                } else _this.$checkUser();
            });

            //-- Adding header for xht USED FOR uploading the images / files
            XMLHttpRequest.prototype.origOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function () {
                this.origOpen.apply(this, arguments);
                //this.setRequestHeader('X-TOKEN', 'the token');
                this.withCredentials = true;
            };

            //-- Clearing array izi
            Array.prototype.clear = function () {
                while (this.length > 0) {
                    this.pop();
                } // Fastest
            };

            //-- Used to compare date in an array (find doesn't work)
            Array.prototype.indexOfDate = function (date) {
                for (var i = 0; i < this.length; i++) {
                    if (+this[i] === +date) return i;
                };
                return -1;
            };
        }
    });
})();

/***/ }),

/***/ "8Eth":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9UPm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MNMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
//import { DOMAIN_TITLE, WWW_IMAGE_PATH } from '@/config/env';

function debounce(fn, delay) {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;

        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
}

/* harmony default export */ __webpack_exports__["b"] = ({
    methods: {
        $updatePageTitle: function $updatePageTitle(to, from) {
            var pageTitle = to.matched.find(function (item) {
                return item.meta.title;
            });
            pageTitle ? window.document.title = pageTitle.meta.title : window.document.title = DOMAIN_TITLE;
            //next();
        },
        $scrollToTop: function $scrollToTop() {
            window.scrollTo(0, 0);
        },
        $scrollTo: function $scrollTo(id) {
            var element = document.getElementById(id);
            //console.log(element.offsetTop);
            element.scrollIntoView();
            //var top = element.offsetTop;
        },
        $tomorrowDate: function $tomorrowDate() {
            var today = new Date();
            var tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);
            return tomorrow;
        },
        $getNavItem: function $getNavItem(value) {
            return this.$getItemFromContents("navigation", value).text;
        },
        $getContent: function $getContent(page, value) {
            return this.$getItemFromContents(page, value).text;
        },
        $getItemFromContents: function $getItemFromContents(contentId, itemName, customLng) {
            var contents = this.$store.state.contents[contentId];
            var lng = !customLng ? this.$getLng() : customLng;
            //console.log("getItemFromContents =>" + contentId + " -> " + itemName + " " + contents.length + ' => ' + lng);

            if (this.$checkNull(contents)) {
                var res = contents.find(function (item) {
                    return item.label == itemName;
                });
                if (this.$checkNull(res)) {
                    res[lng]['images'] = res.images;
                    return res[lng];
                }
                console.log(itemName + " doesn't exist");
                return false;
            } else {
                console.log("contents empty for " + contentId + " => " + itemName);
                return false;
            }
        },
        $getItemFromConfig: function $getItemFromConfig(value, configName, configLabel) {
            var configs = this.$store.state.contents[configName];

            if (this.$checkNull(configs)) {
                var res = configs.find(function (item) {
                    return item[configLabel] == value;
                });
                if (this.$checkNull(res)) {
                    return res;
                }
                console.log(value + "," + configName + "," + configLabel + " doesn't exist");
                return false;
            } else {
                console.log("configs empty for " + value + "," + configName + "," + configLabel);
                return false;
            }
        },
        $getMetaTag: function $getMetaTag(page) {
            //console.log("metaTag for: " + page);
            return {
                title: this.$getItemFromContents(page, "meta_titre").text,
                //titleTemplate: '%s - Yay!',
                htmlAttrs: {
                    lang: this.$getLng(),
                    amp: false
                },
                meta: [{ name: 'description', content: this.$getItemFromContents(page, "meta_description").text }]
            };
        },

        /*
        $validityCheck(context) {
            setInterval(() => {
                if (context.formstate.$invalid) {
                    context.requiredMsg = 'Remplissez les champs requis SVP';
                    context.disabled = true;
                } else {
                    context.requiredMsg = '';
                    context.disabled = false;
                }
            }, 1000)
        },*/
        $checkNull: function $checkNull(value) {
            if (value === '' || value === false || value === null || value === 'undefined' || value === undefined) {
                return false;
            }
            return true;
        },
        $checkMobileFormat: function $checkMobileFormat() {
            if (this.$store.getters.getWindowSize.width < 968) return true;
            return false;
        },
        $closeDetailBox: function $closeDetailBox() {
            this.showDetail = false;
        },
        $toggleCurrentLanguage: function $toggleCurrentLanguage() {
            this.$store.state.lngFront = this.$store.state.lngFront == 'fr' ? this.$store.state.lngFront = 'en' : this.$store.state.lngFront = 'fr';
            this.$changeLngUrl();
            //this.$route.params.extLng = this.$store.state.lngFront;
        },
        $getLng: function $getLng() {
            return this.$store.getters.currentLng;
        },
        $checkSearchString: function $checkSearchString(searchValue) {
            //-- replace invalid chars
            searchValue = searchValue.replace(/[^a-zA-Z0-9éàèê]/g, '');
            if (!this.$checkNull(searchValue) || searchValue.length < 3) return false;else return searchValue;
        },
        $formatDateUs: function $formatDateUs(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getFullYear() + "-" + (startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
        },
        $formatDateNews: function $formatDateNews(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return (startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + startingDate.getFullYear();
        },
        $formatDateTimeFr: function $formatDateTimeFr(date) {
            //-- date must be US YYYY/MM/DD HH:MM
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString('fr-fr', { month: 'short' });
            var day = startingDate.toLocaleString('fr-fr', { weekday: 'short' });
            var dayInt = startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var hours = startingDate.getHours().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var minutes = startingDate.getMinutes().toLocaleString(undefined, { minimumIntegerDigits: 2 });

            return day + ' ' + dayInt + ' ' + month + ' ' + startingDate.getFullYear() + ' ' + hours + ':' + minutes;
        },
        $formatDateFr: function $formatDateFr(date) {
            var noWeekDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "long" });
            var day = noWeekDay ? startingDate.toLocaleString("fr-fr", { weekday: "long" }) : '';
            return day + " " + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + " " + month + " " + startingDate.getFullYear();
        },
        $formatDateFr2: function $formatDateFr2(date) {
            var noWeekDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "long" });
            return month + " " + startingDate.getFullYear();
        },
        $processExecMsg: function $processExecMsg(data) {
            if (!this.$checkNull(data)) this.$Notification.error(data.replace(/<[^>]+>/g, ''));else if (this.$checkNull(data.result)) {
                var code = data.result.code;
                var msg = data.result.msg;

                if (code == '100') {
                    this.$Notification.success("" + msg);
                    return true;
                } else this.$Notification.warn("" + msg);
            } else {
                //-- No return formated, displaying raw result | removing html
                this.$Notification.error(data.replace(/<[^>]+>/g, ''));
            }

            return false;
        },
        $processDataMsg: function $processDataMsg(data) {
            if (this.$checkNull(data.code)) {
                //this.$Notification.warn(`Code: ${data.code} || Msg: ${data.msg}`)
                this.$Notification.warn("" + data.msg);
                return false;
            } else return true;
        },
        $formatBytes: function $formatBytes(bytes) {
            var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            if (bytes === 0) return '0 Bytes';

            var k = 1024;
            var dm = decimals < 0 ? 0 : decimals;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            var i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        $preloadImages: function $preloadImages(urls, allImagesLoadedCallback) {
            var _this = this;

            var loadedCounter = 0;
            var toBeLoadedNumber = urls.length;
            urls.forEach(function (url) {
                _this.$preloadImage(url, function () {
                    loadedCounter++;
                    //console.log('Number of loaded images: ' + loadedCounter);
                    if (loadedCounter == toBeLoadedNumber) {
                        allImagesLoadedCallback();
                    }
                });
            });
        },
        $preloadImage: function $preloadImage(url, anImageLoadedCallback) {
            var img = new Image();
            img.onload = anImageLoadedCallback;
            img.src = url;
        },
        $hexToRgb: function $hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        $existValueArrays: function $existValueArrays(tab1, tab2) {
            if (!Array.isArray(tab1)) return false;
            if (!Array.isArray(tab2)) tab2 = [tab2];
            var rs = false;
            if (this.$checkNull(tab1)) {
                for (var i = 0; i < tab1.length; i++) {
                    if (this.$checkNull(tab2)) tab2.forEach(function (item) {
                        if (tab1[i] == item) rs = true;
                    });
                    if (rs) return true;
                }
            }
        },
        $getSelectData: function $getSelectData(value) {
            return this.$store.state.contents[value];
        }
    }
});

/***/ }),

/***/ "R870":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["0Flw"]);


// WEBPACK FOOTER //
// static/js/app.58f071f932954e5e9ee0.js